var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_640_31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 3.62833C10.917 2.58871 12.3817 2.22516 13.6785 2.71533C14.9752 3.20551 15.8331 4.44707 15.8331 5.83333C15.8331 7.2196 14.9752 8.46116 13.6785 8.95133C12.3817 9.4415 10.917 9.07796 10 8.03833M12.5 17.5H2.5V16.6667C2.5 13.9071 4.74042 11.6667 7.5 11.6667C10.2596 11.6667 12.5 13.9071 12.5 16.6667V17.5L10 3.62833M10 3.62833H15V2.795C15.0003 1.00855 14.0474 -0.64232 12.5003 -1.53566C10.9533 -2.42899 9.04711 -2.42906 7.5 -1.53583M10.8333 5.83333C10.8333 7.67305 9.33972 9.16667 7.5 9.16667C5.66028 9.16667 4.16667 7.67305 4.16667 5.83333C4.16667 3.99362 5.66028 2.5 7.5 2.5C9.33972 2.5 10.8333 3.99362 10.8333 5.83333L10 3.62833",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavUsers);
export default __webpack_public_path__ + "static/media/nav-users.7344fd7d09c717aab6a496a7266f28f5.svg";
export { ForwardRef as ReactComponent };